<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <b-row>
        <b-col cols="12" class="text-right">
          <button
            class="btn btn-info"
            @click="initStaffGrade"
            v-b-modal.modal-staffGrade
          >
            {{ `${this.t.t(dictEnum.LBL_Add)} ` }}
          </button>
        </b-col>
      </b-row>
      <b-row class="h-100">
        <b-col cols="12" class="h-100 pb-5">
          <div class="tab-content bg-white h-100">
            <div class="tab-pane active table-responsive color-table">
              <v-client-table
                :data="tableData"
                :columns="columns"
                :options="options"
              >
                <template slot="Action" slot-scope="props">
                  <div>
                    <font-awesome-icon
                      icon="edit"
                      style="cursor:pointer"
                      v-if="hasRight(Settings.Permission.Change)"
                      v-b-modal.modal-staffGrade
                      @click="editStaffgrade(props.row)"
                    />

                    <font-awesome-icon
                      icon="trash"
                      style="cursor:pointer"
                      v-if="hasRight('AlwDel')"
                      @click="deleteStaffGrade(props.row)"
                    />
                  </div>
                </template>
              </v-client-table>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal
      id="modal-staffGrade"
      :title="mode == 'new' ? t.t(dictEnum.LBL_Add) : t.t(dictEnum.BTN_Update)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="editOrAddStaffGrade"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_StaffGrade) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="staffGrade.StaffGrade"
                maxlength="10"
                :readonly="mode === 'new' ? false : true"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_EngDesc) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="staffGrade.EDesc"
                maxlength="50"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_ChiDesc) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="staffGrade.CDesc"
                maxlength="50"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MenuRightSerivce from "@/service/MenuRightService";
import StaffGradeService from "@/service/StaffGradeService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { StaffGrade } from "@/model/StaffGrade";
import Settings from "../../constants/Settings";

export default {
  components: {},
  computed: {
    t() {
      return t;
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.MM_StaffGrading,
      Settings: Settings,
      columns: ["StaffGrade", "EDesc", "CDesc", "Action"],
      tableData: [],
      dictEnum: dictEnum,
      staffGrade: new StaffGrade(),
      mode: "new",
      options: {
        filterable: false,
        perPageValues: [],
        sortable: [],
        skin: "table table-hover v-midle",
        headings: {
          StaffGrade: "Staff Grading",
          EDesc: "Eng Description",
          CDesc: "Chi Description",
          Action: "Action"
        },
        columnsClasses: {}
      }
    };
  },
  methods: {
    hasRight(key) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    initStaffGrade() {
      this.mode = "new";
      this.staffGrade = new StaffGrade();
    },
    editStaffgrade(grade) {
      this.mode = "edit";
      this.staffGrade = grade;
    },
    async deleteStaffGrade(grade) {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_DeleteStaffGrade)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          staffGrade: grade.StaffGrade,
          UserId: this.$store.getters[StoreGetter.user].UserID
        };

        const response = await StaffGradeService.deleteStaffGrade(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.getDataTable();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async editOrAddStaffGrade() {
      if (!this.staffGrade.StaffGrade) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_StaffGrade) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (!this.staffGrade.EDesc) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (!this.staffGrade.CDesc) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }

      const obj = {
        model: this.staffGrade
      };

      const response =
        this.mode === "new"
          ? await StaffGradeService.addStaffGrade(obj)
          : await StaffGradeService.updateStaffGrade(obj);
      if (response.data.IsSuccess) {
        this.staffGrade = new StaffGrade();

        SweetAlertService.success("Success", response.data.Message);
        this.getDataTable();
      } else {
        this.staffGrade = new StaffGrade();

        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getDataTable() {
      const obj = {};

      const response = await StaffGradeService.getStaffGrades(obj);

      if (response.data.IsSuccess) {
        this.tableData = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    }
  },
  mounted() {
    this.assignRights();
    this.getDataTable();

    this.options = {
      filterable: false,
      perPageValues: [],
      /* texts: {
        limit: "Records : ",
        },*/
      sortable: [],
      skin: "table table-hover v-midle",
      headings: {
        StaffGrade: t.t(dictEnum.MENU_StaffGrading),
        EDesc: t.t(dictEnum.LBL_EngDesc),
        CDesc: t.t(dictEnum.LBL_ChiDesc),
        Action: t.t(dictEnum.BTN_Update)
      },
      texts: {
        noResults: t.t(dictEnum.LBL_NoData),
        count: ``
      },
      columnsClasses: {}
    };
  }
};
</script>
<style scoped>
.input-group-text {
  background: white;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/S050000-MM/S050200-StaffGrading.vue